import axios from "axios";
import Cookies from "js-cookie";

// ---------------------------------
// BASE URL
// ---------------------------------

const BASE_URL = "https://api.avcon.us/";

// ---------------------------------
// COOKIES
// ---------------------------------

export const TOKEN_COOKIE =
  "avcon-token";

export const REFRESH_COOKIE =
  "avcon-refresh-token";

// ---------------------------------
// AXIOS INSTANCE
// ---------------------------------

export const API_BASE_URL =
  axios.create({
    baseURL: BASE_URL,
  });

// ---------------------------------
// REQUEST INTERCEPTOR
// ---------------------------------

API_BASE_URL.interceptors.request.use(

  (req) => {

    const token =
      Cookies.get(TOKEN_COOKIE);

    if (token) {

      if (
        !req.headers.authorization
      ) {

        req.headers.authorization =
          `Bearer ${token}`;
      }
    }

    return req;
  }
);

// ---------------------------------
// SESSION EXPIRED POPUP
// ---------------------------------

const showSessionExpiredPopup =
  () => {

    alert(
      "Your session has expired. Please login again."
    );

    // Clear auth
    Cookies.remove(
      TOKEN_COOKIE
    );

    Cookies.remove(
      REFRESH_COOKIE
    );

    localStorage.clear();

    sessionStorage.clear();

    // Redirect
    window.location.href =
      "/users/sign-in";
  };

// ---------------------------------
// RESPONSE INTERCEPTOR
// ---------------------------------

API_BASE_URL.interceptors.response.use(

  (response) => response,

  async (error) => {

    // IMPORTANT:
    // safer handling for POST failures

    const originalRequest =
      error?.config || {};

    // ---------------------------------
    // UNAUTHORIZED
    // ---------------------------------

    if (

      error?.response?.status === 401 &&

      originalRequest &&

      !originalRequest._retry

    ) {

      originalRequest._retry = true;

      try {

        console.log(
          "401 intercepted, attempting refresh..."
        );

        const refreshToken =
          Cookies.get(
            REFRESH_COOKIE
          );

        // No refresh token
        if (!refreshToken) {

          showSessionExpiredPopup();

          return Promise.reject(
            error
          );
        }

        // ---------------------------------
        // REFRESH ACCESS TOKEN
        // ---------------------------------

        const response =
          await axios.post(

            `${BASE_URL}auth/refresh`,

            {
              refreshToken,
            }
          );

        const newToken =
          response.data.data.token;

        const newRefreshToken =
          response.data.data.refreshToken;

        // Save updated access token
        Cookies.set(
          TOKEN_COOKIE,
          newToken,
          {
            expires: 1,
            sameSite: "Lax",
          }
        );

        // Save updated refresh token
        Cookies.set(
          REFRESH_COOKIE,
          newRefreshToken,
          {
            expires: 1,
            sameSite: "Lax",
          }
        );

        // Retry original request
        originalRequest.headers.authorization =
          `Bearer ${newToken}`;

        return API_BASE_URL(
          originalRequest
        );

      } catch (refreshError) {

        console.error(
          "Refresh token failed",
          refreshError
        );

        showSessionExpiredPopup();

        return Promise.reject(
          refreshError
        );
      }
    }

    return Promise.reject(error);
  }
);
